export enum JobBoardCodename {
  Arbeitnow = 'arbeitnow',
  FashionUnited = 'fashionunited',
  FigaroClassifieds = 'figaro-classifieds',
  GoogleForJobs = 'google_for_jobs',
  Indeed = 'indeed',
  Jobcase = 'jobcase',
  Jobilino = 'jobilino',
  Jobissim = 'jobissim',
  Linkedin = 'linkedin-limited-listings',
  MegaEmploi = 'megaemploi',
  Monster = 'monster',
  MyJobHelper = 'my-job-helper',
  Zippia = 'zippia',
  Inhire = 'inhire',
}

export enum JobBoardActivatedStatus {
  Submitted = 'submitted',
  Rejected = 'rejected',
}
